export enum CoverageState {
    financial,
    finish
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/CoverageState.ts